export default "__VITE_ASSET__CouKt_sl__"